import React from 'react'

function QuestionSub2({ width, height, className, color = "currentColor" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 12.1 13.135"
            fill="none"
            stroke={color} // Apply dynamic stroke color
            strokeLinejoin="round"
            strokeWidth="1.1"
        >
            <path d="M2,6.518H8M2,3.782H8m1,0h1M9,6.518h1M9,9.253h1m-8,0H8M.5.5h11V12.535H.5Z" transform="translate(0.05 0.05)" />
        </svg>
    );
}

export default QuestionSub2;
